import { render } from "./EditVan.vue?vue&type=template&id=42b2f4c6"
import script from "./EditVan.vue?vue&type=script&lang=js"
export * from "./EditVan.vue?vue&type=script&lang=js"

import "./EditVan.vue?vue&type=style&index=0&id=42b2f4c6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__